import {connect} from 'react-redux'
import {decryptContainer} from './actions'
import component from './component'

const mapDispatchToProps = (dispatch) => ({
  decryptContainer: data => dispatch(decryptContainer(data))
})

export default connect(null, mapDispatchToProps)(component)
